export default __webpack_public_path__ + "static/media/grid-row-2 copy.c72438a2.svg";